// ============================================================
// types/fum.types.ts — Ficha Única de Matrícula (FUM / SIAGIE)
// ============================================================

export type ParentescoTutor = 'PADRE' | 'MADRE' | 'TUTOR' | 'APODERADO';

export interface TutorMatriculaPayload {
  matriculaId: number;
  parentesco: ParentescoTutor;
  nombres: string;
  apellidos: string;
  dni: string;
  ocupacion: string;
  celular: string;
  email: string;
  viveConEstudiante: boolean;
  esContactoPrincipal: boolean;
}

export interface TutorMatriculaResponse {
  idTutorMatricula: number;
  matriculaId: number;
  parentesco: ParentescoTutor;
  nombres: string;
  apellidos: string;
  dni: string;
  ocupacion: string;
  celular: string;
  email: string;
  viveConEstudiante: boolean;
  esContactoPrincipal: boolean;
  activo: boolean;
}

export type TipoSangre = 'A_POS' | 'A_NEG' | 'B_POS' | 'B_NEG' | 'O_POS' | 'O_NEG' | 'AB_POS' | 'AB_NEG';

export interface DatosSaludPayload {
  matriculaId: number;
  pesoKg: number | null;
  tallaCm: number | null;
  tipoSangre: TipoSangre | null;
  alergias: string | null;
  condicionEspecial: string | null;
  discapacidad: boolean;
  tipoDiscapacidad: string | null;
  seguroSalud: string | null;
  numeroSeguro: string | null;
}

export interface DatosSaludResponse extends DatosSaludPayload {
  idDatosSalud: number;
}

export const PARENTESCO_LABEL: Record<ParentescoTutor, string> = {
  PADRE: 'Padre',
  MADRE: 'Madre',
  TUTOR: 'Tutor',
  APODERADO: 'Apoderado',
};

export const TIPO_SANGRE_LABEL: Record<TipoSangre, string> = {
  A_POS: 'A+', A_NEG: 'A-',
  B_POS: 'B+', B_NEG: 'B-',
  O_POS: 'O+', O_NEG: 'O-',
  AB_POS: 'AB+', AB_NEG: 'AB-',
};

export const TUTOR_VACIO: Omit<TutorMatriculaPayload, 'matriculaId'> = {
  parentesco: 'PADRE',
  nombres: '',
  apellidos: '',
  dni: '',
  ocupacion: '',
  celular: '',
  email: '',
  viveConEstudiante: true,
  esContactoPrincipal: false,
};
